// extracted by mini-css-extract-plugin
module.exports = {"container":"ContactView_container__1N5DT","content":"ContactView_content__2cw-R"};